/**
 * Click-to-load YouTube: .jaromin-video with data-youtube-id and/or
 * data-youtube-list, or an existing iframe. Playlist embeds get visible
 * prev/next + a skip list (YouTube's own playlist chrome is easy to miss).
 */
(function () {
  var PLAY_LABEL = 'Play video';
  var API_SRC = 'https://www.youtube.com/iframe_api';
  var playerSeq = 0;
  var apiWaiters = [];

  function videoIdFromSrc(src) {
    var m = String(src || '').match(/(?:embed\/|youtu\.be\/|v=)([A-Za-z0-9_-]{11})/);
    if (!m || m[1] === 'videoseries') return null;
    return m[1];
  }

  function listIdFromSrc(src) {
    var m = String(src || '').match(/[?&]list=([A-Za-z0-9_-]+)/);
    return m ? m[1] : null;
  }

  function embedSrc(id, list) {
    if (list) {
      return 'https://www.youtube.com/embed/videoseries?list=' + encodeURIComponent(list) + '&rel=0';
    }
    if (id) return 'https://www.youtube.com/embed/' + id + '?rel=0';
    return '';
  }

  function withAutoplay(src, forApi) {
    try {
      var u = new URL(src, 'https://www.youtube.com');
      u.searchParams.set('autoplay', '1');
      u.searchParams.set('rel', '0');
      u.searchParams.set('playsinline', '1');
      if (forApi) {
        u.searchParams.set('enablejsapi', '1');
        u.searchParams.set('origin', window.location.origin);
      }
      return u.toString();
    } catch (e) {
      return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1';
    }
  }

  function posterFor(container, id) {
    var custom = container.getAttribute('data-poster');
    if (custom) return custom;
    if (id) return 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    return '';
  }

  function makeIframe(src, title, forApi) {
    var iframe = document.createElement('iframe');
    iframe.src = withAutoplay(src, forApi);
    iframe.title = title || 'YouTube video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('width', '560');
    iframe.setAttribute('height', '315');
    if (forApi) {
      playerSeq += 1;
      iframe.id = 'jaromin-yt-' + playerSeq;
    }
    return iframe;
  }

  function loadIframeApi(done) {
    if (window.YT && window.YT.Player) {
      done();
      return;
    }
    apiWaiters.push(done);
    if (document.querySelector('script[src="' + API_SRC + '"]')) return;

    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prev === 'function') prev();
      var queue = apiWaiters.slice();
      apiWaiters.length = 0;
      queue.forEach(function (fn) {
        fn();
      });
    };

    var script = document.createElement('script');
    script.src = API_SRC;
    document.head.appendChild(script);
  }

  function playlistIds(player) {
    var ids = player.getPlaylist && player.getPlaylist();
    return ids && ids.length ? ids : [];
  }

  function whenPlaylistReady(player, tries, done) {
    var ids = playlistIds(player);
    if (ids.length || tries <= 0) {
      done(ids);
      return;
    }
    window.setTimeout(function () {
      whenPlaylistReady(player, tries - 1, done);
    }, 250);
  }

  function bindPlaylist(container, iframe, listId, fallbackTitle) {
    var existing = container.nextElementSibling;
    if (existing && existing.classList.contains('jaromin-yt-playlist')) existing.remove();

    var nav = document.createElement('nav');
    nav.className = 'jaromin-yt-playlist';
    nav.setAttribute('aria-label', 'Playlist');
    nav.innerHTML =
      '<div class="jaromin-yt-playlist__controls">' +
      '<button type="button" class="jaromin-yt-playlist__skip" data-dir="-1">Previous</button>' +
      '<p class="jaromin-yt-playlist__status" aria-live="polite"></p>' +
      '<button type="button" class="jaromin-yt-playlist__skip" data-dir="1">Next</button>' +
      '</div>' +
      '<p class="jaromin-yt-playlist__now"></p>' +
      '<ol class="jaromin-yt-playlist__items"></ol>' +
      '<a class="jaromin-yt-playlist__open" href="https://www.youtube.com/playlist?list=' +
      encodeURIComponent(listId) +
      '" target="_blank" rel="noopener">Open playlist on YouTube</a>';
    container.insertAdjacentElement('afterend', nav);

    var statusEl = nav.querySelector('.jaromin-yt-playlist__status');
    var nowEl = nav.querySelector('.jaromin-yt-playlist__now');
    var listEl = nav.querySelector('.jaromin-yt-playlist__items');
    var skipBtns = nav.querySelectorAll('.jaromin-yt-playlist__skip');
    var titles = {};
    var player;

    function currentTitle() {
      var data = player && player.getVideoData && player.getVideoData();
      if (data && data.video_id && data.title) titles[data.video_id] = data.title;
      if (data && data.title) return data.title;
      return fallbackTitle || 'The Boondocker';
    }

    function render(ids) {
      var index = player.getPlaylistIndex ? player.getPlaylistIndex() : 0;
      if (index < 0) index = 0;
      var total = ids.length;
      statusEl.textContent = total ? index + 1 + ' of ' + total : '';
      nowEl.textContent = currentTitle();
      skipBtns[0].disabled = !total || index <= 0;
      skipBtns[1].disabled = !total || index >= total - 1;

      if (!listEl.dataset.built && total) {
        listEl.dataset.built = '1';
        ids.forEach(function (id, i) {
          var li = document.createElement('li');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'jaromin-yt-playlist__item';
          btn.dataset.index = String(i);
          btn.setAttribute('aria-label', 'Play video ' + (i + 1));
          btn.innerHTML =
            '<img src="https://i.ytimg.com/vi/' +
            id +
            '/mqdefault.jpg" alt="" width="320" height="180" loading="lazy" decoding="async">' +
            '<span>' +
            (i + 1) +
            '</span>';
          btn.addEventListener('click', function () {
            if (player && player.playVideoAt) player.playVideoAt(i);
          });
          li.appendChild(btn);
          listEl.appendChild(li);
        });
      }

      listEl.querySelectorAll('.jaromin-yt-playlist__item').forEach(function (btn, i) {
        var on = i === index;
        btn.classList.toggle('is-current', on);
        if (on) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });
    }

    skipBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!player) return;
        if (btn.getAttribute('data-dir') === '-1' && player.previousVideo) player.previousVideo();
        if (btn.getAttribute('data-dir') === '1' && player.nextVideo) player.nextVideo();
      });
    });

    function boxSize() {
      var r = container.getBoundingClientRect();
      return {
        w: Math.max(160, Math.round(r.width)),
        h: Math.max(90, Math.round(r.height)),
      };
    }

    function fitPlayer() {
      if (!player || !player.setSize) return;
      var s = boxSize();
      player.setSize(s.w, s.h);
    }

    loadIframeApi(function () {
      var s = boxSize();
      player = new window.YT.Player(iframe.id, {
        width: s.w,
        height: s.h,
        events: {
          onReady: function (event) {
            player = event.target;
            fitPlayer();
            whenPlaylistReady(player, 20, render);
          },
          onStateChange: function (event) {
            player = event.target;
            fitPlayer();
            render(playlistIds(player));
          },
        },
      });
    });
  }

  function makeFacade(container, id, list, src, title) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'jaromin-yt-facade';
    btn.setAttribute('aria-label', title ? PLAY_LABEL + ': ' + title : PLAY_LABEL);

    var poster = posterFor(container, id);
    if (poster) {
      var img = document.createElement('img');
      img.src = poster;
      img.alt = '';
      img.width = 480;
      img.height = 360;
      img.loading = 'lazy';
      img.decoding = 'async';
      btn.appendChild(img);
    }

    var play = document.createElement('span');
    play.className = 'jaromin-yt-facade__play';
    play.setAttribute('aria-hidden', 'true');

    btn.appendChild(play);
    btn.addEventListener('click', function () {
      var iframe = makeIframe(src, title, !!list);
      btn.replaceWith(iframe);
      if (list) bindPlaylist(container, iframe, list, title);
    });
    return btn;
  }

  function enhance(container) {
    if (!container || container.getAttribute('data-yt-ready') === '1') return;
    container.setAttribute('data-yt-ready', '1');

    var existing = container.querySelector('iframe');
    var id = container.getAttribute('data-youtube-id');
    var list = container.getAttribute('data-youtube-list');
    var title = container.getAttribute('data-youtube-title') || (existing && existing.title) || '';
    var src;

    if (existing && existing.getAttribute('src')) {
      id = id || videoIdFromSrc(existing.getAttribute('src'));
      list = list || listIdFromSrc(existing.getAttribute('src'));
      existing.remove();
    }
    src = embedSrc(id, list);

    if (!src || (!id && !list)) {
      container.removeAttribute('data-yt-ready');
      return;
    }

    var noscript = container.querySelector('noscript');
    if (noscript) noscript.remove();

    var staleNav = container.nextElementSibling;
    if (staleNav && staleNav.classList.contains('jaromin-yt-playlist')) staleNav.remove();

    container.appendChild(makeFacade(container, id, list, src, title));
  }

  function boot() {
    document.querySelectorAll('.jaromin-video').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
